import { c as _c } from "react/compiler-runtime";
import { useSnackbar } from "notistack";
import { useEffect, useRef } from "react";
import { useAppSelector } from "#/store/hooks";
import { PyodideLoadingSnackbarContent } from "../ui/PyodideLoadingSnackbarContent";
const PYODIDE_LOADING_SNACKBAR_KEY = "pyodide-loading";

/**
 * Single source of truth for the Pyodide loading snackbar.
 * Call near the Python code runner; shows snackbar when progress is non-null, hides when null.
 */
export function usePyodideProgressSnackbar() {
  const $ = _c(8);
  const progress = useAppSelector(_temp);
  const {
    enqueueSnackbar,
    closeSnackbar
  } = useSnackbar();
  const hasSnackbarShownRef = useRef(false);
  let t0;
  let t1;
  if ($[0] !== closeSnackbar || $[1] !== enqueueSnackbar || $[2] !== progress) {
    t0 = () => {
      if (progress !== null) {
        if (!hasSnackbarShownRef.current) {
          hasSnackbarShownRef.current = true;
          enqueueSnackbar(<PyodideLoadingSnackbarContent />, {
            variant: "info",
            persist: true,
            key: PYODIDE_LOADING_SNACKBAR_KEY
          });
        }
      } else {
        if (hasSnackbarShownRef.current) {
          hasSnackbarShownRef.current = false;
          closeSnackbar(PYODIDE_LOADING_SNACKBAR_KEY);
        }
      }
    };
    t1 = [progress, enqueueSnackbar, closeSnackbar];
    $[0] = closeSnackbar;
    $[1] = enqueueSnackbar;
    $[2] = progress;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[5] !== closeSnackbar) {
    t2 = () => () => {
      if (hasSnackbarShownRef.current) {
        closeSnackbar(PYODIDE_LOADING_SNACKBAR_KEY);
      }
    };
    t3 = [closeSnackbar];
    $[5] = closeSnackbar;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
}
function _temp(state) {
  return state.pyodide.progress;
}